import { DDocumento } from "@dian/api-formulario";
import { CasillaValor } from "../configuracion/dformulario2100-configuracion";

export class InitializeModelService {

    private confCasillas: CasillaValor[];
    private confCasillasCompuestas: [number[]];

    constructor(
        confCasillas: CasillaValor[],
        confCasillasCompuestas: [number[]]
    ) {
        this.confCasillas = confCasillas;
        this.confCasillasCompuestas = confCasillasCompuestas;
    }

    initializeModel(model: DDocumento): DDocumento {
        //Inicializa casillas simples
        for (const item of this.confCasillas) {
            
            const value = model.doc.cuerpo[item.casilla];
            switch (item.tipo) {
                case 'number':
                    model.doc.cuerpo[item.casilla] = value || value == '0' ? value : '0';
                    break;
                case 'string':
                    model.doc.cuerpo[item.casilla] = value || value == '0' ? value : '';
                    break;
                case 'obj':
                    model.doc.cuerpo[item.casilla] = value ? value : [];
                    break;
                default:
                    model.doc.cuerpo[item.casilla] = value || value == '0' ? value : null;
                    break;
            }

            //Excepciones:
            if (item.casilla == "cs_id_385")
                model.doc.cuerpo[item.casilla] = value && value != '0' ? value : '1';
        }

        //Inicializa casillas compuestas
        const prefix = 'cc_id_';
        for(let i=Number(this.confCasillasCompuestas[0][0]); i<=Number(this.confCasillasCompuestas[0][1]); i++)
        {
            const data = model.doc.cuerpo[prefix + i];
            if (data && Array.isArray(data) && data.length)
                continue;
            model.doc.cuerpo[prefix + i] = [];
        }
     /*   for (const item of this.confCasillasCompuestas) {
            for (const subItem of item) {
                const data = model.doc.cuerpo[prefix + subItem];
                if (data && Array.isArray(data) && data.length)
                    continue;
                model.doc.cuerpo[prefix + subItem] = [];
            }
        }
*/
        //CONFIGURACION_CASILLAS_2100
        return model;
    }
}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/services/Initialize-model.service.ts